import Vue from 'vue';
import VueI18n from 'vue-i18n';
import LocalStorage from '@/services/localstorage';

Vue.use(VueI18n);

const messages = {
  id: {
    our_services: 'Layanan Kami',
    news_and_promos: 'Berita & Promo',
    partnership: 'Kemitraan',
    about_partnership: 'Tentang Kemitraan',
    services: 'Layanan',
    location: 'Lokasi',
    contact: 'Kontak',
    content: 'Isi',
    paxelbox_services: 'Layanan PaxelBox',
    read_more: 'Baca Lebih Lanjut',
    location_caption: 'Dimana Kita Temukan PaxelBox?',
    location_description: 'Anda dapat menemukan PaxelBox di lebih dari 260 lokasi di sekitar Jabodetabek, ',
    and_still_growing: 'dan masih terus berkembang!',
    contact_caption: 'Keunggulan PaxelBox',
    contact_value_1: 'Notifikasi<br>Otomatis',
    contact_value_2: 'Bisa di Akses<br>24/7',
    contact_value_3: 'Beragam Ukuran<br>S, M, L, XL',
    contact_value_4: 'Lebih Aman<br>dan Privasi',
    contact_value_5: 'Tanpa Kontak<br>Fisik',
    contact_value_6: 'Mudah<br>Digunakan',
    contact_form_caption: 'Tertarik untuk Bekerja Sama?',
    contact_form_description: 'Bawa PaxelBox lebih dekat kepadamu',
    fill_form: 'Isi Form',
    choose_business_type: 'Pilih Tipe Bisnis',
    individu: 'Individu',
    business: 'Bisnis',
    about_paxel: 'Tentang Paxel',
    support: 'Bantuan',
    terms_and_conditions: 'Syarat & Ketentuan',
    privacy_policy: 'Kebijakan Privasi',
    follow_us: 'Ikuti Kami',
    download_our_app: 'Download Aplikasi Paxel',
    how_to_use: 'Cara Penggunaan',
    download_paxel_app: 'Unduh Aplikasi Paxel',
    guest_book: 'Buku Tamu',
    sender_name: 'Nama Pengirim',
    sender_contact: 'Kontak Pengirim',
    email_address: 'Alamat Email',
    what_do_you_want: 'Apa yang Anda inginkan',
    paxelbox_locker: 'PaxelBox Loker',
    about_services_and_partnership_with_paxelbox: 'Tentang layanan dan kerjasama dengan PaxelBox',
    advertise_on_paxelbox: 'Beriklan di PaxelBox',
    place_your_ad_on_paxelbox: 'Pasang iklan Anda di PaxelBox',
    message: 'Pesan',
    guest_book_term_check: 'Dengan ini saya menyetujui <a href={url}>Syarat dan Ketentuan</a> yang berlaku dan setuju untuk mengirimkan data di atas untuk digunakan oleh Paxel.',
    send_and_download_white_paper: 'Kirim & Download White Paper',
    enter_sender_name: 'Masukkan nama pengirim',
    enter_sender_contact: 'Masukkan kontak pengirim',
    enter_email_address: 'Masukkan alamat email',
    enter_your_message: 'Masukkan pesan Anda',
    should_not_empty: 'tidak boleh kosong',
    you_should_choose_one: 'Anda harus memilih salah satu',
    you_should_accept_terms_and_conditions: 'Anda harus menerima Syarat dan Ketentuan',
    not_valid: 'tidak valid',
    between_length: 'harus diawali 0 dan antara {min} sampai {max} angka',
    back_to_paxelbox: 'Kembali Ke PaxelBox',
    something_wrong: 'Terjadi kesalahan server, silahkan hubungi Customer Service kami',
    data_package: 'Paket Data',
    delivery_provider: 'Jasa Pengiriman',
    recipient_name: 'Nama Penerima',
    recipient_mobile_number: 'Telepon Penerima',
    locker_location: 'Lokasi Loker',
    package_size: 'Ukuran Paket',
    package_photo: 'Foto Paket',
    select_photo: 'Pilih Photo',
    change_photo: 'Ubah Photo',
    preview_photo: 'Lihat Photo',
    package_photo_and_airwaybill: 'Foto paket dan airwaybill',
    slider_verification: 'Verifikasi Slider',
    confirm: 'Konfirmasi',
    enter_recipient_name: 'Masukkan nama penerima',
    enter_recipient_mobile_number: 'Masukkan telepon penerima',
    choose_package_size: 'Pilih ukuran paket',
    etc: 'dll',
    ex: 'Contoh',
    swipe_to_the_righ_side: 'Geser ke sebelah kanan',
    verification_success: 'Verifikasi sukses',
    please_swipe_for_verification: 'Mohon menggeser untuk verifikasi',
    your_data_has_been_submitted: 'Data Anda telah dikirim',
    your_white_paper_download: 'White Paper Anda akan mulai segera diunduh, Terima kasih atas minat Anda pada Paxelbox',
    your_request_could_not_be_found: 'Permintaan Anda tidak dapat ditemukan. Silakan periksa alamat shortener anda',
    your_page_could_not_be_found: 'Halaman yang Anda maksud tidak dapat ditemukan. Silakan periksa alamat url anda',
    no_locker_available: 'Tidak ada locker yang tersedia',
    track_shipment: 'Cek Resi',
    check_rates: 'Cek Ongkir',
    pbx: {
      skip: 'Langsung ke konten utama',
      brand: 'PaxelBox',
      nav: {
            kegunaan: 'Kegunaan',
            caraPakai: 'Cara Pakai',
            ukuran: 'Ukuran',
            lokasi: 'Lokasi',
            faq: 'FAQ',
            cari: 'Cari Paxelbox',
      },
      hero: {
            eyebrow: 'Smart locker untuk aktivitasmu',
            headline: 'Barang Aman,\nBebas Gerak.',
            support: 'Titip barang bawaan di Paxelbox, lanjut aktivitas tanpa ribet.',
            ctaFind: 'Cari Paxelbox Terdekat',
            ctaHow: 'Cara Pakai Paxelbox',
      },
      lifestyle: {
            heading: 'Aktivitas Jalan Terus',
            sub: 'Bebas gerak tanpa repot nenteng barang bawaan dengan Paxelbox.',
            items: [
                  {
                        title: 'Olahraga atau lari?',
                        context: 'Titip barang bawaan dan fokus gerak tanpa ribet.',
                        action: 'Cari di Area Olahraga',
                  },
                  {
                        title: 'Nonton konser?',
                        context: 'Simpan barang bawaan dan nikmati konser dengan lebih bebas.',
                        action: 'Cari Paxelbox Terdekat',
                  },
                  {
                        title: 'Lagi sibuk, ada paket datang?',
                        context: 'Simpan paket di locker dan ambil nanti.',
                        action: 'Lihat Cara Ambil Paket',
                  },
                  {
                        title: 'Bawa helm atau tas besar?',
                        context: 'Pilih ukuran locker yang pas dan lanjut aktivitas dengan lebih ringan.',
                        action: 'Lihat Ukuran Locker',
                  },
            ],
      },
      kegunaan: {
            heading: 'Bikin Aktivitas Lebih Praktis',
            sub: 'Satu tempat penitipan barang untuk berbagai kebutuhan di tengah aktivitasmu.',
            items: [
                  {
                        title: 'Titip Barang',
                        copy: 'Simpan tas, helm, perlengkapan olahraga, atau barang bawaan sebelum melanjutkan aktivitas.',
                        cta: 'Lihat Cara Titip Barang',
                  },
                  {
                        title: 'Terima dan Ambil Paket',
                        copy: 'Paket tetap tersimpan meskipun kamu sedang tidak berada di tempat.',
                        cta: 'Lihat Cara Ambil Paket',
                  },
                  {
                        title: 'Kirim Paket',
                        copy: 'Buat pengiriman lewat layanan Lew@tBox dan masukkan paketmu ke locker Paxelbox.',
                        cta: 'Lihat Cara Kirim Paket',
                  },
            ],
      },
      cara: {
            heading: 'Semua Bisa Dilakukan dari Aplikasi Paxel',
            sub: 'Pilih kebutuhanmu, ikuti langkahnya, lalu lanjut aktivitas.',
            tabTitip: 'Titip Barang',
            tabAmbil: 'Ambil Paket',
            tabDropoff: 'Kirim Paket',
            flows: {
                  titip: {
                        heading: 'Cara Titip Barang di Paxelbox',
                        steps: [
                              {
                                    title: 'Buka menu Paxelbox',
                                    text: 'Buka menu Paxelbox di aplikasi Paxel.',
                              },
                              {
                                    title: 'Cari Paxelbox terdekat',
                                    text: 'Temukan titik yang paling dekat dengan lokasi atau aktivitasmu.',
                              },
                              {
                                    title: 'Pilih locker',
                                    text: 'Sesuaikan ukuran dan durasi dengan barang yang ingin disimpan.',
                              },
                              {
                                    title: 'Scan dan simpan',
                                    text: 'Gunakan QR Code untuk membuka locker, lalu simpan barangmu.',
                              },
                        ],
                  },
                  ambil: {
                        heading: 'Cara Ambil Paket di Paxelbox',
                        steps: [
                              {
                                    title: 'Buka menu Paxelbox',
                                    text: 'Buka menu Paxelbox di aplikasi Paxel.',
                              },
                              {
                                    title: "Pilih 'Ambil Paket di Locker'",
                                    text: "Pilih menu 'Ambil Paket di Locker' pada aplikasi.",
                              },
                              {
                                    title: 'Scan dan buka locker',
                                    text: 'Gunakan QR Code yang tertera untuk membuka locker.',
                              },
                        ],
                  },
                  dropoff: {
                        heading: 'Cara Kirim Paket di Paxelbox',
                        steps: [
                              {
                                    title: 'Buka menu Lew@tBox',
                                    text: 'Pilih menu Lew@tBox di aplikasi Paxel.',
                              },
                              {
                                    title: 'Cari Paxelbox terdekat',
                                    text: 'Temukan Paxelbox yang paling dekat dengan lokasimu.',
                              },
                              {
                                    title: 'Masukkan detail paket',
                                    text: 'Masukkan tujuan dan detail paket yang akan dikirim.',
                              },
                              {
                                    title: 'Scan dan buka locker',
                                    text: 'Scan QR Code yang tertera untuk membuka locker.',
                              },
                        ],
                  },
            },
      },
      ukuran: {
            heading: 'Selalu Ada Ukuran yang Pas',
            sub: 'Pilih loker penitipan barang sesuai ukuran barang bawaanmu.',
            note: 'Dimensi dalam format Tinggi x Panjang x Lebar. Kapasitas dapat berbeda tergantung bentuk dan susunan barang.',
            exampleLabel: 'Contoh barang:',
            sizeWord: 'Ukuran',
            dimSuffix: '(T x P x L)',
            sizes: [
                  {
                        key: 'S',
                        label: 'Buat Barang Kecil',
                        items: 'Sandal, botol kecil, dokumen',
                        dim: '12 x 47,5 x 47,5 cm',
                  },
                  {
                        key: 'M',
                        label: 'Buat Kebutuhan Harian',
                        items: 'Sepatu, tas laptop, jaket',
                        dim: '24 x 47,5 x 47,5 cm',
                  },
                  {
                        key: 'L',
                        label: 'Buat Barang Lebih Besar',
                        items: 'Helm, bola basket, dan barang seukuran',
                        dim: '36 x 47,5 x 47,5 cm',
                  },
                  {
                        key: 'XL',
                        label: 'Buat Bawaan Ekstra',
                        items: 'Koper, galon air, dan barang seukuran',
                        dim: '59 x 47,5 x 47,5 cm',
                  },
            ],
            seli: {
                  badge: 'Loker Khusus',
                  title: 'SeliBox/KoperBox',
                  copy: 'Loker khusus yang dirancang untuk penitipan sepeda lipat (seli) atau koper secara aman.',
                  dim: '87 x 85 x 47,5 cm (T x P x L)',
            },
      },
      trust: {
            heading: 'Titip dengan Tenang',
            sub: 'Barang tersimpan dengan aman, kamu bisa fokus lanjutkan aktivitas.',
            items: [
                  {
                        title: 'Tinggal Scan untuk Akses',
                        copy: 'Buka locker lewat QR Code di aplikasi.',
                  },
                  {
                        title: 'Notifikasi Otomatis',
                        copy: 'Status penyimpanan dikirim otomatis ke kamu.',
                  },
                  {
                        title: 'Dipantau CCTV 24/7',
                        copy: 'Area Paxelbox dilengkapi pengawasan CCTV 24 jam.',
                  },
                  {
                        title: 'Dekat dengan Aktivitasmu',
                        copy: 'Temukan Paxelbox di berbagai titik strategis.',
                  },
                  {
                        title: 'Akses Kapan Aja Selama Masa Sewa',
                        copy: 'Buka dan tutup pintu Paxelbox berkali-kali selama masa sewa.',
                  },
                  {
                        title: 'Sewa Paxelbox dari Mana Aja',
                        copy: 'Sewa dari rumah, kantor, atau pas di jalan lewat aplikasi Paxel.',
                  },
            ],
      },
      lokasi: {
            eyebrow: 'Tinggal cari titik terdekat',
            heading: 'Temukan Paxelbox Terdekat',
            sub: 'Cari berdasarkan nama lokasi, alamat, atau kode locker Paxelbox.',
            searchPlaceholder: 'Cari area, gedung, atau tempat',
            searchBtn: 'Cari Paxelbox',
            useLocation: 'Pakai Lokasiku',
            viewList: 'Daftar',
            viewMap: 'Peta',
            fieldOpen: 'Hari operasional',
            fieldHours: 'Jam operasional',
            fieldCode: 'Kode locker',
            directions: 'Petunjuk Arah',
            detail: 'Lihat Detail',
            detailClose: 'Tutup Detail',
            detailPrefix: 'Alamat lengkap:',
            detailCode: 'Kode locker:',
            detailOpen: 'Buka',
            detailHoursLabel: 'jam operasional',
            nearest: 'Terdekat dari lokasimu',
            empty: 'Lokasi tidak ditemukan.',
            emptyHint: 'Coba kata kunci lain.',
            loading: 'Memuat lokasi…',
            geoBusy: 'Mendeteksi lokasi…',
            geoUnavailable: 'Tidak bisa mengakses lokasimu. Aktifkan izin lokasi di browser, atau cari lokasi secara manual di kolom pencarian.',
            dismiss: 'Tutup',
            more: 'Lihat Lebih Banyak',
            mapTitle: 'Peta lokasi Paxelbox',
      },
      kolaborasi: {
            heading: 'Kolaborasi bersama Paxelbox',
            opt1Title: 'Hadirkan Paxelbox di Lokasimu',
            opt1Copy: 'Berikan kemudahan penitipan barang bagi pengunjung.',
            opt2Title: 'Pasang Iklan di Paxelbox',
            opt2Copy: 'Manfaatkan Paxelbox sebagai media branding yang dekat dengan aktivitas sehari-hari.',
            cta: 'Ajukan Kerja Sama',
      },
      ads: {
            kerjasama: 'Kerja Sama Paxelbox',
            kolaborasi: 'Kolaborasi Paxelbox',
            branding: 'Branding Iklan Paxelbox',
            media: 'Media Branding Paxelbox',
      },
      partners: {
            heading: 'Dipercaya oleh Berbagai Partner',
            placeholder: 'Ruang logo partner',
      },
      testimoni: {
        heading: 'Apa Kata Mereka?',
        sub: 'Cerita dari pengguna dan partner bisnis yang sudah pakai Paxelbox.',
        items: [
          { name: 'Rangga P.', role: 'Pengguna Paxelbox', quote: 'Habis kerja mau langsung olahraga, tasnya tinggal titip di Paxelbox. Praktis!' },
          { name: 'Dinda A.', role: 'Pengguna Paxelbox', quote: 'Nonton konser jadi makin nyaman, barang tinggal titip di Paxelbox!' },
          { name: 'Zahra', role: 'Pengguna Paxelbox', quote: 'Pas lagi main di Blok M bawaannya banyak, jadi aku titip dulu di Paxelbox. Jalan-jalannya jadi lebih nyaman.' },
          { name: 'Ryan', role: 'Pengguna Paxelbox', quote: 'Naik MRT sambil bawa banyak barang jadi nggak ribet. Tinggal titip di Paxelbox, terus lanjut aktivitas.' },
          { name: 'Audia Cendekiawati', role: 'Procurement Specialist, PPKGBK', quote: 'Terima kasih Paxel sudah menjadi bagian dalam menghadirkan solusi yang inovatif, praktis, dan relevan bagi kebutuhan GBK People. Kolaborasi ini didukung oleh komunikasi yang baik, respons cepat, serta semangat untuk terus mencari solusi terbaik bersama.' },
        ],
      },
      ig: {
            heading: 'Ikuti Update Terbaru Paxelbox',
            sub: 'Follow Instagram Paxelbox buat dapetin info terbaru dan ikuti berbagai keseruannya!',
      },
      appdl: {
            heading: 'Semua Lebih Praktis dari Aplikasi Paxel',
            text: 'Cari lokasi, pilih locker, dan akses QR Code langsung dari aplikasi.',
      },
      appstoreSmall: 'Download on the',
      appstoreName: 'App Store',
      playSmall: 'GET IT ON',
      playName: 'Google Play',
      faq: {
            heading: 'Semua yang Perlu Kamu Tahu',
            sub: 'Cara pakai, ukuran, biaya, sampai bantuan Paxelbox ada di sini.',
            stillNeed: 'Masih butuh bantuan?',
            heraHours: 'Asisten Chat Paxel, Hera aktif Senin-Minggu, jam 08.30-22.00 WIB.',
            chatHera: 'Chat dengan Hera',
            items: [
                  {
                        q: 'Apa itu Paxelbox?',
                        a: 'Paxelbox adalah tempat penitipan barang dan loker penitipan barang pintar dari Paxel untuk titip barang dan kebutuhan paket, supaya kamu bisa lanjut aktivitas tanpa terus membawa barang.',
                  },
                  {
                        q: 'Paxelbox bisa digunakan untuk apa saja?',
                        a: 'Bisa buat titip barang, menerima paket saat kamu lagi nggak di tempat, sampai kirim paket.',
                  },
                  {
                        q: 'Bagaimana cara menggunakan Paxelbox?',
                        a: 'Cari Paxelbox terdekat lewat aplikasi Paxel, pilih locker, selesaikan sewa locker dan scan QR Code pada Paxelbox untuk membuka locker.',
                  },
                  {
                        q: 'Barang apa saja yang bisa disimpan?',
                        a: 'Barang sehari-hari seperti tas, helm, perlengkapan olahraga, dokumen, sampai paket, selama sesuai ukuran dan ketentuan Paxelbox.',
                  },
                  {
                        q: 'Bagaimana cara memilih ukuran locker?',
                        a: 'Cocokkan barangmu dengan ukuran S, M, L, atau XL sesuai dimensi yang tersedia.',
                  },
                  {
                        q: 'Berapa harga sewa Paxelbox?',
                        a: 'Harga dapat berbeda-beda tergantung ukuran locker dan durasi penyimpanan. Cek biaya sewanya langsung di aplikasi Paxel.',
                  },
                  {
                        q: 'Bagaimana cara menghubungi bantuan Paxelbox?',
                        a: 'Kamu dapat hubungi Asisten Chat Paxel, Hera, lewat aplikasi Paxel. Hera aktif Senin-Minggu, jam 08.30-22.00 WIB.',
                  },
            ],
      },
      footer: {
            aboutPaxel: 'Tentang Paxel',
            aboutPartnership: 'Tentang Kemitraan',
            help: 'Bantuan',
            complaint: 'Layanan Pengaduan Konsumen',
            followUs: 'Ikuti Kami',
            downloadApp: 'Unduh Aplikasi Paxel',
            l_about: 'Tentang Paxel',
            l_services: 'Layanan Kami',
            l_info: 'Pusat Informasi Paxel',
            l_news: 'Berita & Promo',
            l_kebaikan: '#AntarkanKebaikan',
            l_corporate: 'Corporate',
            l_mitra: 'Mitra PaxelCo',
            l_big: 'PaxelBig',
            l_box: 'PaxelBox',
            l_ongkir: 'Cek Ongkir',
            l_resi: 'Cek Resi',
            l_terms: 'Syarat & Ketentuan',
            l_privacy: 'Kebijakan Privasi',
            l_career: 'Karir',
            c_company: 'PT Global Unggul Mandiri (PAXEL)',
            c_email: 'wehearyou@paxel.co',
            c_ditjen: 'Direktorat Jenderal Perlindungan Konsumen dan Tertib Niaga',
            c_kementerian: 'Kementerian Perdagangan Republik Indonesia',
            c_wa: 'WhatsApp Ditjen PKTN : 0853 1111 1010',
            rights: 'Seluruh Hak Cipta',
      },
},
  },
  en: {
    our_services: 'Our Services',
    news_and_promos: 'News & Promo',
    partnership: 'Partnership',
    about_partnership: 'About Partnership',
    services: 'Services',
    location: 'Location',
    contact: 'Contact',
    content: 'Content',
    paxelbox_services: 'PaxelBox Services',
    read_more: 'Read More',
    location_caption: 'Where We Find PaxelBox?',
    location_description: 'You can find PaxelBox on more than 260 locations around Jabodetabek, ',
    and_still_growing: 'and still growing!',
    contact_caption: 'PaxelBox Value',
    contact_value_1: 'Automatic<br>Notification',
    contact_value_2: 'Accessible<br>24/7',
    contact_value_3: 'Various Size<br>S, M, L, XL',
    contact_value_4: 'More Safe<br>and Private',
    contact_value_5: 'No Physical<br>Contact',
    contact_value_6: 'Easy<br>to Use',
    contact_form_caption: 'Interested for Partnership?',
    contact_form_description: 'Bring PaxelBox closer to you',
    fill_form: 'Fill Form',
    choose_business_type: 'Choose Business Type',
    individu: 'Individu',
    business: 'Business',
    about_paxel: 'About Paxel',
    support: 'Support',
    terms_and_conditions: 'Terms & Conditions',
    privacy_policy: 'Privacy Policy',
    follow_us: 'Follow Us',
    download_our_app: 'Download Our App',
    how_to_use: 'How To Use',
    download_paxel_app: 'Download Paxel App',
    guest_book: 'Guest Book',
    sender_name: 'Sender Name',
    sender_contact: 'Sender Contact',
    email_address: 'Email Address',
    what_do_you_want: 'What do You want',
    paxelbox_locker: 'PaxelBox Locker',
    about_services_and_partnership_with_paxelbox: 'About services and partnership with PaxelBox',
    advertise_on_paxelbox: 'Advertise on PaxelBox',
    place_your_ad_on_paxelbox: 'Place Your ads on PaxelBox',
    message: 'Message',
    guest_book_term_check: 'I hereby agree to the applicable <a href={url}>Terms and Conditions</a> and agree to submit the above data for use by Paxel.',
    send_and_download_white_paper: 'Send & Download White Paper',
    enter_sender_name: 'Enter sender name',
    enter_sender_contact: 'Enter sender contact',
    enter_email_address: 'Enter email address',
    enter_your_message: 'Enter Your message',
    should_not_empty: 'should not empty',
    you_should_choose_one: 'You should choose one',
    you_should_accept_terms_and_conditions: 'You should accept Terms and Conditions',
    not_valid: 'not valid',
    between_length: 'should started 0 and between {min} to {max} numbers',
    back_to_paxelbox: 'Back to PaxelBox',
    something_wrong: 'A server error occurred, please contact our Customer Service',
    data_package: 'Data Package',
    delivery_provider: 'Delivery Provider',
    recipient_name: 'Recipient Name',
    recipient_mobile_number: 'Recipient Mobile Number',
    locker_location: 'Locker Location',
    package_size: 'Package Size',
    package_photo: 'Package Photo',
    select_photo: 'Select Photo',
    change_photo: 'Change Photo',
    preview_photo: 'Preview Photo',
    package_photo_and_airwaybill: 'Package photo and airwaybill',
    slider_verification: 'Slider Verification',
    enter_recipient_name: 'Enter recipient name',
    enter_recipient_mobile_number: 'Enter recipient mobile number',
    choose_package_size: 'Choose package size',
    confirm: 'Confirm',
    etc: 'etc',
    ex: 'Ex',
    swipe_to_the_righ_side: 'Swipe to the right side',
    verification_success: 'Verification Success',
    please_swipe_for_verification: 'Please swipe for verification',
    your_data_has_been_submitted: 'Your data has been submited',
    your_white_paper_download: 'Your White Paper download will begin shortly, Thank you for your interest in Paxelbox',
    your_request_could_not_be_found: 'Your request could not be found. Please check your shortener address',
    your_page_could_not_be_found: 'Your request page could not be found. Please check your url address',
    no_locker_available: 'No locker available',
    track_shipment: 'Track Shipment',
    check_rates: 'Check Rates',
    pbx: {
      skip: 'Skip to main content',
      brand: 'PaxelBox',
      nav: {
            kegunaan: 'Uses',
            caraPakai: 'How To',
            ukuran: 'Sizes',
            lokasi: 'Locations',
            faq: 'FAQ',
            cari: 'Find a Paxelbox',
      },
      hero: {
            eyebrow: 'A smart locker for your day',
            headline: 'Your Things Safe,\nYou Stay Free.',
            support: 'Drop your bags at a Paxelbox and get on with your day, hassle-free.',
            ctaFind: 'Find the Nearest Paxelbox',
            ctaHow: 'How Paxelbox Works',
      },
      lifestyle: {
            heading: 'Keep Moving',
            sub: 'Move freely without lugging your things around, with Paxelbox.',
            items: [
                  {
                        title: 'Working out or going for a run?',
                        context: 'Drop your things off and move freely, no hassle.',
                        action: 'Find One Near Sports Venues',
                  },
                  {
                        title: 'Heading to a concert?',
                        context: 'Store your bags and enjoy the show with your hands free.',
                        action: 'Find the Nearest Paxelbox',
                  },
                  {
                        title: 'Busy and a package is arriving?',
                        context: 'Store the package in a locker and pick it up later.',
                        action: 'See How to Collect a Package',
                  },
                  {
                        title: 'Carrying a helmet or a big bag?',
                        context: 'Pick the right locker size and carry on with less to hold.',
                        action: 'See Locker Sizes',
                  },
            ],
      },
      kegunaan: {
            heading: 'Make Your Day Simpler',
            sub: 'One place to store your things for whatever your day needs.',
            items: [
                  {
                        title: 'Store Your Things',
                        copy: 'Stash a bag, helmet, sports gear, or whatever you are carrying before you carry on.',
                        cta: 'See How to Store',
                  },
                  {
                        title: 'Receive and Collect Packages',
                        copy: 'Your package stays safe even when you are not around to receive it.',
                        cta: 'See How to Collect',
                  },
                  {
                        title: 'Send Packages',
                        copy: 'Create a shipment through Lew@tBox and drop your package into a Paxelbox locker.',
                        cta: 'See How to Send',
                  },
            ],
      },
      cara: {
            heading: 'Everything from the Paxel App',
            sub: 'Pick what you need, follow the steps, then carry on.',
            tabTitip: 'Store Things',
            tabAmbil: 'Collect a Package',
            tabDropoff: 'Send a Package',
            flows: {
                  titip: {
                        heading: 'How to Store Things at Paxelbox',
                        steps: [
                              {
                                    title: 'Open the Paxelbox menu',
                                    text: 'Open the Paxelbox menu in the Paxel app.',
                              },
                              {
                                    title: 'Find the nearest Paxelbox',
                                    text: 'Find the point closest to your location or activity.',
                              },
                              {
                                    title: 'Choose a locker',
                                    text: 'Match the size and duration to what you want to store.',
                              },
                              {
                                    title: 'Scan and store',
                                    text: 'Use the QR code to open the locker, then store your things.',
                              },
                        ],
                  },
                  ambil: {
                        heading: 'How to Collect a Package at Paxelbox',
                        steps: [
                              {
                                    title: 'Open the Paxelbox menu',
                                    text: 'Open the Paxelbox menu in the Paxel app.',
                              },
                              {
                                    title: "Choose 'Collect Package from Locker'",
                                    text: "Select the 'Collect Package from Locker' menu in the app.",
                              },
                              {
                                    title: 'Scan and open the locker',
                                    text: 'Use the QR code shown to open the locker.',
                              },
                        ],
                  },
                  dropoff: {
                        heading: 'How to Send a Package at Paxelbox',
                        steps: [
                              {
                                    title: 'Open the Lew@tBox menu',
                                    text: 'Select the Lew@tBox menu in the Paxel app.',
                              },
                              {
                                    title: 'Find the nearest Paxelbox',
                                    text: 'Find the Paxelbox closest to you.',
                              },
                              {
                                    title: 'Enter the package details',
                                    text: 'Enter the destination and details of the package to send.',
                              },
                              {
                                    title: 'Scan and open the locker',
                                    text: 'Scan the QR code shown to open the locker.',
                              },
                        ],
                  },
            },
      },
      ukuran: {
            heading: "There's Always a Size That Fits",
            sub: 'Pick a storage locker to match what you are carrying.',
            note: 'Dimensions are shown as Height x Length x Width. Capacity varies with the shape and arrangement of your items.',
            exampleLabel: 'Fits, for example:',
            sizeWord: 'Size',
            dimSuffix: '(H x L x W)',
            sizes: [
                  {
                        key: 'S',
                        label: 'For Small Items',
                        items: 'Sandals, a small bottle, documents',
                        dim: '12 x 47.5 x 47.5 cm',
                  },
                  {
                        key: 'M',
                        label: 'For Daily Needs',
                        items: 'Shoes, a laptop bag, a jacket',
                        dim: '24 x 47.5 x 47.5 cm',
                  },
                  {
                        key: 'L',
                        label: 'For Larger Items',
                        items: 'A helmet, a basketball, and similar',
                        dim: '36 x 47.5 x 47.5 cm',
                  },
                  {
                        key: 'XL',
                        label: 'For Extra Loads',
                        items: 'A suitcase, a water gallon, and similar',
                        dim: '59 x 47.5 x 47.5 cm',
                  },
            ],
            seli: {
                  badge: 'Special Locker',
                  title: 'SeliBox/KoperBox',
                  copy: 'A special locker designed to safely store a folding bike (seli) or a suitcase.',
                  dim: '87 x 85 x 47.5 cm (H x L x W)',
            },
      },
      trust: {
            heading: 'Store with Peace of Mind',
            sub: 'Your things are stored safely so you can focus on your day.',
            items: [
                  {
                        title: 'Just Scan to Access',
                        copy: 'Open the locker with a QR code in the app.',
                  },
                  {
                        title: 'Automatic Notifications',
                        copy: 'Storage status is sent to you automatically.',
                  },
                  {
                        title: 'Monitored by 24/7 CCTV',
                        copy: 'Paxelbox areas are covered by 24-hour CCTV.',
                  },
                  {
                        title: 'Close to Your Activities',
                        copy: 'Find Paxelbox at various strategic points.',
                  },
                  {
                        title: 'Access Anytime During Your Rental',
                        copy: 'Open and close the Paxelbox door as often as you like during your rental.',
                  },
                  {
                        title: 'Rent a Paxelbox from Anywhere',
                        copy: 'Rent from home, the office, or on the go through the Paxel app.',
                  },
            ],
      },
      lokasi: {
            eyebrow: 'Just find the nearest point',
            heading: 'Find the Nearest Paxelbox',
            sub: 'Search by location name, address, or Paxelbox locker code.',
            searchPlaceholder: 'Search an area, building, or place',
            searchBtn: 'Find a Paxelbox',
            useLocation: 'Use My Location',
            viewList: 'List',
            viewMap: 'Map',
            fieldOpen: 'Open days',
            fieldHours: 'Open hours',
            fieldCode: 'Locker code',
            directions: 'Directions',
            detail: 'See Details',
            detailClose: 'Hide Details',
            detailPrefix: 'Full address:',
            detailCode: 'Locker code:',
            detailOpen: 'Open',
            detailHoursLabel: 'operating hours',
            nearest: 'Nearest to you',
            empty: 'No location found.',
            emptyHint: 'Try another keyword.',
            loading: 'Loading locations…',
            geoBusy: 'Detecting your location…',
            geoUnavailable: 'We could not access your location. Enable location permission in your browser, or search manually in the field above.',
            dismiss: 'Dismiss',
            more: 'Show More',
            mapTitle: 'Paxelbox location map',
      },
      kolaborasi: {
            heading: 'Collaborate with Paxelbox',
            opt1Title: 'Bring Paxelbox to Your Location',
            opt1Copy: 'Give your visitors an easy way to store their things.',
            opt2Title: 'Advertise on Paxelbox',
            opt2Copy: "Use Paxelbox as a branding medium close to people's everyday activities.",
            cta: 'Propose a Partnership',
      },
      ads: {
            kerjasama: 'Paxelbox Partnership',
            kolaborasi: 'Paxelbox Collaboration',
            branding: 'Paxelbox Ad Branding',
            media: 'Paxelbox Media Branding',
      },
      partners: {
            heading: 'Trusted by Various Partners',
            placeholder: 'Partner logo space',
      },
      testimoni: {
        heading: 'What People Say',
        sub: 'Stories from users and business partners who already use Paxelbox.',
        items: [
          { name: 'Rangga P.', role: 'Paxelbox user', quote: 'Straight from work to a workout, I just drop my bag at a Paxelbox. So easy!' },
          { name: 'Dinda A.', role: 'Paxelbox user', quote: 'Concerts are so much comfier now, I just leave my things at a Paxelbox!' },
          { name: 'Zahra', role: 'Paxelbox user', quote: 'Out at Blok M with a lot to carry, so I stored it at a Paxelbox first. Wandering around was much nicer.' },
          { name: 'Ryan', role: 'Paxelbox user', quote: 'Taking the MRT with a lot to carry is no hassle now. Just store it at a Paxelbox and carry on.' },
          { name: 'Audia Cendekiawati', role: 'Procurement Specialist, PPKGBK', quote: 'Thank you, Paxel, for being part of bringing innovative, practical and relevant solutions to the needs of GBK People. This collaboration is backed by good communication, fast responses and a shared drive to keep finding the best solutions together.' },
        ],
      },
      ig: {
            heading: 'Follow the Latest from Paxelbox',
            sub: 'Follow Paxelbox on Instagram for the latest updates and all the fun!',
      },
      appdl: {
            heading: 'Everything Is Simpler from the Paxel App',
            text: 'Find a location, pick a locker, and access the QR code straight from the app.',
      },
      appstoreSmall: 'Download on the',
      appstoreName: 'App Store',
      playSmall: 'GET IT ON',
      playName: 'Google Play',
      faq: {
            heading: 'Everything You Need to Know',
            sub: 'How it works, sizes, pricing, and Paxelbox help are all here.',
            stillNeed: 'Still need help?',
            heraHours: "Paxel's chat assistant, Hera, is available Mon-Sun, 08.30-22.00 WIB.",
            chatHera: 'Chat with Hera',
            items: [
                  {
                        q: 'What is Paxelbox?',
                        a: 'Paxelbox is a smart storage locker from Paxel for storing your things and handling packages, so you can carry on without holding your things the whole time.',
                  },
                  {
                        q: 'What can Paxelbox be used for?',
                        a: 'For storing your things, receiving packages when you are not around, and even sending packages.',
                  },
                  {
                        q: 'How do I use Paxelbox?',
                        a: 'Find the nearest Paxelbox in the Paxel app, choose a locker, complete the locker rental, and scan the QR code on the Paxelbox to open it.',
                  },
                  {
                        q: 'What can I store?',
                        a: 'Everyday items like bags, helmets, sports gear, documents, and packages, as long as they fit the size and Paxelbox terms.',
                  },
                  {
                        q: 'How do I choose a locker size?',
                        a: 'Match your item to size S, M, L, or XL according to the available dimensions.',
                  },
                  {
                        q: 'How much does a Paxelbox rental cost?',
                        a: 'Pricing varies by locker size and storage duration. Check the rental cost directly in the Paxel app.',
                  },
                  {
                        q: 'How do I contact Paxelbox support?',
                        a: "You can reach Paxel's chat assistant, Hera, in the Paxel app. Hera is available Mon-Sun, 08.30-22.00 WIB.",
                  },
            ],
      },
      footer: {
            aboutPaxel: 'About Paxel',
            aboutPartnership: 'About Partnership',
            help: 'Help',
            complaint: 'Consumer Complaint Service',
            followUs: 'Follow Us',
            downloadApp: 'Download the Paxel App',
            l_about: 'About Paxel',
            l_services: 'Our Services',
            l_info: 'Paxel Information Center',
            l_news: 'News & Promo',
            l_kebaikan: '#AntarkanKebaikan',
            l_corporate: 'Corporate',
            l_mitra: 'PaxelCo Partner',
            l_big: 'PaxelBig',
            l_box: 'PaxelBox',
            l_ongkir: 'Check Rates',
            l_resi: 'Track Shipment',
            l_terms: 'Terms & Conditions',
            l_privacy: 'Privacy Policy',
            l_career: 'Careers',
            c_company: 'PT Global Unggul Mandiri (PAXEL)',
            c_email: 'wehearyou@paxel.co',
            c_ditjen: 'Directorate General of Consumer Protection and Orderly Commerce',
            c_kementerian: 'Ministry of Trade of the Republic of Indonesia',
            c_wa: 'WhatsApp Ditjen PKTN : 0853 1111 1010',
            rights: 'All Rights Reserved',
      },
},
  },
};

const i18n = new VueI18n({
  locale: LocalStorage.getLanguage(), // set locale
  fallbackLocale: 'id', // set fallback locale
  messages, // set locale messages
});

export default i18n;
